var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomRentVsBuy = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "m16.162 20.125.556-.333v2.574h3.227v-1.718h1.407v1.718h3.227v-2.574l.556.333.724-1.206-5.21-3.126-5.21 3.126zM5.42 19.792v2.574h3.228v-1.718h1.407v1.718h3.227v-2.574l.556.333.724-1.206-5.21-3.126-5.21 3.126.723 1.206z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E2969",
    d: "M3 23.772h24V27H3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.848 11.937-.472-.52-1.043.944.473.52c.635.702 1.523 1.194 2.49 1.404v1.427h1.407v-1.33a3.537 3.537 0 0 0 1.815-.692c.595-.455.99-1.077 1.11-1.752a2.426 2.426 0 0 0-.412-1.84c-.398-.575-1.026-1.023-1.867-1.334-.22-.08-.437-.163-.646-.245V5.758c.542.087 1.058.322 1.537.701l.552.436.872-1.103-.551-.436c-.858-.678-1.709-.941-2.41-1.017V3h-1.406v1.418c-.109.026-.186.05-.226.063-1.045.309-1.786 1.124-1.936 2.13a2.388 2.388 0 0 0 1.061 2.378c.031.02.52.242 1.1.481v3.365a3.233 3.233 0 0 1-1.448-.898zm1.075-4.154a.983.983 0 0 1-.397-.966c.061-.411.345-.747.77-.926v2.054a38.71 38.71 0 0 1-.373-.162zm1.939 2.301c.995.367 1.499.953 1.382 1.607-.1.56-.663 1.15-1.54 1.277v-2.943l.158.059z",
    fill: "#1B7690"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomRentVsBuy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-rent-vs-buy.2b9ce8191cdd3a3fe448988718a26ce8.svg";